/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type script = {
    /**
     * Script hash
     */
    script_hash: string;
    /**
     * Type of the script language
     */
    type: script.type;
    /**
     * The size of the CBOR serialised script, if a Plutus script
     */
    serialised_size: number | null;
};

export namespace script {

    /**
     * Type of the script language
     */
    export enum type {
        TIMELOCK = 'timelock',
        PLUTUS_V1 = 'plutusV1',
        PLUTUS_V2 = 'plutusV2',
    }


}
